<template>
  <div id="app">
    <DocumentEditor />
  </div>
</template>

<script>
import DocumentEditor from './components/DocumentEditor.vue'

export default {
  name: 'App',
  components: {
    DocumentEditor
  }
}
</script>

<style>
body{
  padding:0px;
  margin:0px;
  overflow: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
